import styled from 'styled-components/macro';
import { useMediaQuery } from 'react-responsive';

import Loading, { LoadingProps } from '../SubComponents/Loading';
import { Modal } from '../SubComponents/Modals';
import { CloseButton, ModalButton } from '../SubComponents/Buttons';
import { ReactComponent as Close } from '../Assets/Icons/close.svg';
import CustomerInfo from '../ui-components/CustomerInfo';
import { Label } from '../SubComponents/Text';
import useFormatPrice from '../Hooks/use-format-price';
import useTypeSafeLocalize from '../Hooks/use-type-safe-localize';
import { LocalizationCategory, ProductLocalization } from '../localizations/types';
import { Customer } from '../redusers/customer-reducer';

const LabelWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
`;

interface LoadingPaymentModalProps {
  customer: Customer;
  toBePaid: number | undefined;
  onClose: () => void;
}

const LoadingPaymentModal = (props: LoadingPaymentModalProps) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const localize = useTypeSafeLocalize();
  const formatPrice = useFormatPrice();

  const loadingProps: LoadingProps = {
    delay: 0,
  };

  return (
    <Modal mb={isMobile ? 5 : 4}>
      {isMobile && (
        <CloseButton icon={Close} altText="Close payment modal" onClick={props.onClose} />
      )}
      <CustomerInfo customer={props.customer} showBirthDate={false} />

      <div style={{ margin: '0 auto' }}>
        <Loading {...loadingProps} />
      </div>

      <LabelWrapper>
        <Label textAlign="center">
          {localize(LocalizationCategory.product, ProductLocalization.toBePaid)}:{' '}
          {props.toBePaid ? formatPrice(props.toBePaid) : '-'}
        </Label>
      </LabelWrapper>

      <ModalButton
        isLoading={false}
        onClick={() => console.log('Pay for booking')}
        disabled={true}
      >
        {localize(LocalizationCategory.product, ProductLocalization.confirmBooking)}
      </ModalButton>
    </Modal>
  );
};

export default LoadingPaymentModal;
